<template>
  <div
    class="user-process-window"
    :class="{
      'user-process-window-danger': type === 'danger',
      'user-process-window-success': type === 'success',
      'user-process-window-whitened-out': filtersMode,
    }"
  >
    <div class="user-process-header">
      <div class="window-title">
        {{ title }}
        {{
          title === "Do zrobienia" && data && data.length > 0
            ? `(${data.length})`
            : ""
        }}
      </div>
      <div
        v-if="type !== 'danger'"
        :class="{
          'cursor-pointer': type !== 'success',
          'active-user-process-button': filtersMode,
        }"
        class="user-process-window-button"
        @click="toggleFiltersMode"
      >
        {{
          type === "success"
            ? parseInt(ratio * 100)
                .toFixed(0)
                .toString() + "%"
            : "Filtr"
        }}
      </div>
    </div>
    <!-- <div v-if="!filtersMode && refresh" class="searchbox">
      <primary-input
        :value="searchValue"
        @change="newSearchValue"
        :placeholder="'Szukaj po numerze telefonu...'"
      />
    </div> -->
    <div v-if="!filtersMode" class="user-process-data">
      <user-process-window-element
        @click="newUserProcessChosen"
        v-for="element in data"
        :key="element.id"
        :data="element"
        :type="type ? type : null"
      />
    </div>
    <div v-else class="user-process-filters">
      <custom-checkbox
        @check="newCheckOnCurrent"
        :title="type === 'todo' ? 'Aktualne' : 'Telefon'"
        :checked="currentChecked"
      />
      <custom-checkbox
        @check="newCheckOnPostponed"
        :title="type === 'todo' ? 'Przełożone' : 'SMS'"
        :checked="postponedChecked"
      />
      <custom-button :size="'large'" @click="saveFilters" :title="'Zapisz'" />
    </div>
  </div>
</template>

<script>
import CustomButton from "./CustomButton.vue";
import CustomCheckbox from "./CustomCheckbox.vue";
import UserProcessWindowElement from "./UserProcessWindowElement.vue";
export default {
  components: {
    UserProcessWindowElement,
    CustomCheckbox,
    CustomButton,
  },
  name: "UserProcessWindow",
  props: ["title", "data", "type", "ratio"],
  emits: ["refresh", "process-chosen"],
  data() {
    return {
      filtersMode: false,
      searchValue: "",
      routerPath: "",
      refresh: true,
      currentChecked: this.setCurrentCheck(),
      postponedChecked: this.setPostPonedCheck(),
    };
  },

  watch: {
    $route() {
      if (this.$router.currentRoute.query.type != this.routerPath) {
        this.currentChecked = this.setCurrentCheck();
        this.postponedChecked = this.setPostPonedCheck();
        this.refresh = false;
        this.searchValue = "";
        this.refresh = true;
      }
    },
  },
  methods: {
    setCurrentCheck() {
      let queries = this.$router.currentRoute.query;
      let flag = false;
      if (
        (queries.filterWith &&
          queries.filterWith === "CURRENT" &&
          this.type === "todo") ||
        (queries.filterWithSecond &&
          queries.filterWithSecond === "PHONE" &&
          this.type === "done")
      )
        flag = true;

      return flag;
    },
    setPostPonedCheck() {
      let queries = this.$router.currentRoute.query;
      let flag = false;
      if (
        (queries.filterWith &&
          queries.filterWith === "FOR_LATER" &&
          this.type === "todo") ||
        (queries.filterWithSecond &&
          queries.filterWithSecond === "SMS" &&
          this.type === "done")
      )
        flag = true;

      return flag;
    },
    toggleFiltersMode() {
      if (this.type !== "success") this.filtersMode = !this.filtersMode;
    },
    newUserProcessChosen(e) {
      this.$emit("process-chosen", e);
    },
    saveFilters() {
      let category = this.$router.currentRoute.query.type;
      let filterBy = this.$router.currentRoute.query.filterBy;
      let filterWith = this.$router.currentRoute.query.filterWith;
      let filterBySecond = this.$router.currentRoute.query.filterBySecond;
      let filterWithSecond = this.$router.currentRoute.query.filterWithSecond;
      let search = this.$router.currentRoute.query.search;
      if (this.currentChecked || this.postponedChecked) {
        if (this.type === "todo") {
          filterBy = "completion_status";
          filterWith = this.currentChecked ? "CURRENT" : "FOR_LATER";
        } else {
          filterBySecond = "contact_type";
          filterWithSecond = this.currentChecked ? "PHONE" : "SMS";
        }
      } else {
        if (this.type === "todo") {
          filterBy = "";
          filterWith = "";
        } else {
          filterBySecond = "";
          filterWithSecond = "";
        }
      }
      this.$router.push({
        name: "UserProcess",
        query: {
          type: category,
          filterWith: filterWith,
          filterBy: filterBy,
          filterWithSecond: filterWithSecond,
          filterBySecond: filterBySecond,
          search: search,
        },
      });
      this.refreshWindow();
      this.filtersMode = false;
    },
    newCheckOnCurrent(e) {
      if (e === true) {
        this.currentChecked = true;
        this.postponedChecked = false;
      } else {
        this.currentChecked = false;
      }
    },
    newCheckOnPostponed(e) {
      if (e === true) {
        this.currentChecked = false;
        this.postponedChecked = true;
      } else {
        this.postponedChecked = false;
      }
    },
    async refreshWindow() {
      const queries = this.$router.currentRoute.query;
      let filterBy = "";
      let filterWith = "";
      let filterBySecond = "";
      let filterWithSecond = "";
      let type = "";
      let search = "";
      if (queries.search) search = queries.search;
      if (queries.type) type = queries.type;
      if (queries.filterBy) filterBy = queries.filterBy;
      if (queries.filterWith) filterWith = queries.filterWith;
      if (queries.filterBySecond) filterBySecond = queries.filterBySecond;
      if (queries.filterWithSecond) filterWithSecond = queries.filterWithSecond;
      await this.$store.dispatch("fetchProcesses", {
        status:
          this.type === "todo"
            ? "WAITING_FOR_CONTACT"
            : this.type === "done"
            ? "PENDING_ACTION"
            : this.type === "success"
            ? "SUCCESS"
            : "LOST",
        type: type,
        filterBy: filterBy,
        filterWith: filterWith,
        filterBySecond: filterBySecond,
        filterWithSecond: filterWithSecond,
        search: search,
      });
    },
    async newSearchValue(e) {
      this.searchValue = e;
      await this.refreshWindow();
    },
  },
};
</script>

<style scoped>
.window-title {
  font-size: 22px;
  font-weight: 500;
  color: #090741;
}
.user-process-window {
  width: 308px;
  height: 530px;
  border: 2px solid rgba(9, 7, 65, 0.75);
  border-radius: 5px;
  padding: 0;
}
.user-process-data {
  max-height: 420px;
  max-width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.user-process-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-process-window-button {
  width: 68px;
  height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 4px 20px;
  gap: 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #090741;
  border: 1px solid #090741;
  border-radius: 5px;
}
.user-process-window-danger {
  background: rgba(236, 9, 9, 0.05);
  border: 2px solid #ec0909;
}
.user-process-window-success {
  background: rgba(14, 167, 84, 0.05);
  border: 2px solid #0ea754;
}
.user-process-window-whitened-out {
  background: #fff;
}
.cursor-pointer {
  cursor: pointer;
}
.active-user-process-button {
  background: #090741;
  border: 1px solid #090741;
  color: white;
}
</style>
